'use client';

import { Button } from '@nextui-org/react';
import { Modal } from '@nextui-org/react';
import { ModalBody } from '@nextui-org/react';
import { ModalContent } from '@nextui-org/react';
import { ModalFooter } from '@nextui-org/react';
import { ModalHeader } from '@nextui-org/react';
import { useDisclosure } from '@nextui-org/react';
import { LogIn } from 'lucide-react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook for redirection
import React from 'react';

export default function AuthAlert() {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  React.useEffect(() => {
    onOpen();
  }, [onOpen]);

  const handleCancel = () => {
    navigate('/');
    onClose();
  };

  const handleRedirect = () => {
    navigate('/login');
    onClose();
  };

  return (
    <div className='d-flex justify-content-center'>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalContent className='p-4'>
          <ModalHeader className='flex justify-between items-center'>
            <div className='text-xl font-bold'>Session Expired!</div>
          </ModalHeader>
          <ModalBody className='my-2'>
            <p className='text-base text-gray-dark'>Your session has expired due to inactivity. Please log in to continue.</p>
          </ModalBody>
          <ModalFooter className='mt-4 flex justify-between'>
            <Button color='secondary' invert onClick={handleCancel}>
              Cancel
            </Button>
            <Button color='primary' onClick={handleRedirect} className='flex items-center'>
              <LogIn className='mr-1' /> Redirect to Login
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
}
export { AuthAlert };
